import { Autocomplete, Checkbox, FormControl, FormControlLabel, Stack, Button, FormGroup, Grid, MenuItem, Select, TextField, Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { searchJob } from '../../actions/userAuth';
import { useDispatch } from 'react-redux';

export default function CandidateJobSidebar({ setLoading, setJobs }) {
  const [selectedTitle, setSelectedTitle] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSkills, setSelectedSkills] = useState('');
  const [selectedCareerLevel, setSelectedCareerLevel] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [payload, setPayload] = useState({});
  const [checkedItems, setCheckedItems] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    showAll: false,
  });
  const [IndustryType, setIndustryType] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    showAll: false,
  });

  const companies = [
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },
    { name: 'MNC (323)' },

  ];

  const dispatch = useDispatch();

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };

  const handleViewAllClick = () => {
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !prevCheckedItems.showAll,
    }));
  };

  const handleViewAllClick1 = () => {
    setIndustryType((prevCheckedItems) => ({
      ...prevCheckedItems,
      showAll: !prevCheckedItems.showAll,
    }));
  };

  const handleLocationChange = (event, value) => {
    setSelectedLocation(value);
  };

  const handleTitleChange = (event) => {
    setPayload({ ...payload, jobTitle: event.target.value });
    setSelectedTitle(event.target.value);
  };

  const handleChange = (event) => {
    setPayload({ ...payload, jobCategory: event.target.value });
    setSelectedCategory(event.target.value);
  };

  const handleSelectedSkills = (event) => {
    setPayload({ ...payload, skills: event.target.value });
    setSelectedSkills(event.target.value);
  };

  const handleCareerLevelChange = (event) => {
    setPayload({ ...payload, careerLevel: event.target.value });
    setSelectedCareerLevel(event.target.value);
  };

  const handleIndustryChange = (event) => {
    const { name, checked } = event.target;
    setIndustryType((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
  };


  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    // Perform search logic here
  };

  useEffect(() => {
    setLoading(true);
    dispatch(searchJob(payload, (data) => {
      setJobs(data.data)
      setLoading(false);
    }))
  }, [payload]);

  return (
    <Grid container>
      <Grid item md={12} px={3}>
        <Stack
          my={2}
          sx={{
            background: 'linear-gradient(to right, #C8D8F1 30%, #F2F4FB 90%)', // Specify your gradient colors
            borderRadius: '10px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            padding: '1rem',
          }}
        >

<Typography variant='body1' className='text1Bold' my={1}>Location</Typography>
          <Autocomplete
            value={selectedLocation}
            onChange={handleLocationChange}
            options={['New York', 'London', 'Paris', 'Tokyo']} // Replace with your location options
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                placeholder="Enter location"
                variant="outlined"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <LocationOnIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{ background: 'white', border: 'none' }} // Updated style
              />
            )}
          />


<Typography variant='body1' className='text1Bold' mt={4}>Job Type</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.checkbox1}
                    onChange={handleCheckboxChange}
                    name="checkbox1"
                  />
                }
                label="Freelance"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.checkbox2}
                    onChange={handleCheckboxChange}
                    name="checkbox2"
                  />
                }
                label="Full Time"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.checkbox3}
                    onChange={handleCheckboxChange}
                    name="checkbox3"
                  />
                }
                label="Intership "
              />
            </FormGroup>
          </FormControl>

          {checkedItems.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedItems.checkbox4}
                      onChange={handleCheckboxChange}
                      name="checkbox4"
                    />
                  }
                  label="Checkbox 4"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedItems.checkbox5}
                      onChange={handleCheckboxChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedItems.checkbox6}
                      onChange={handleCheckboxChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick}>
            {checkedItems.showAll ? "Show Less" : "View All"}
          </Button>




       
      


          <Typography variant='body1' className='text1Bold' my={1}>Experience</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox1}
                    onChange={handleIndustryChange}
                    name="checkbox1"
                  />
                }
                label="Fresher"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox2}
                    onChange={handleIndustryChange}
                    name="checkbox2"
                  />
                }
                label="0-2 years"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox3}
                    onChange={handleIndustryChange}
                    name="checkbox3"
                  />
                }
                label="2-5 years"
              />
            </FormGroup>
          </FormControl>

          {IndustryType.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IndustryType.checkbox4}
                      onChange={handleIndustryChange}
                      name="checkbox4"
                    />
                  }
                  label="5+ Year"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IndustryType.checkbox5}
                      onChange={handleIndustryChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IndustryType.checkbox6}
                      onChange={handleIndustryChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick1}>
            {IndustryType.showAll ? "Show Less" : "View All"}
          </Button>
          <Typography variant='body1' className='text1Bold' my={1}>Education Background</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox1}
                    onChange={handleIndustryChange}
                    name="checkbox1"
                  />
                }
                label="IT Services & Consulting (143)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox2}
                    onChange={handleIndustryChange}
                    name="checkbox2"
                  />
                }
                label="Service Product (354)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox3}
                    onChange={handleIndustryChange}
                    name="checkbox3"
                  />
                }
                label="E-Learning/EdTech (345)"
              />
            </FormGroup>
          </FormControl>

          {IndustryType.showAll && (
            <FormControl component="fieldset" sx={{ border: 'none' }}>
              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IndustryType.checkbox4}
                      onChange={handleIndustryChange}
                      name="checkbox4"
                    />
                  }
                  label="5+ Year"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IndustryType.checkbox5}
                      onChange={handleIndustryChange}
                      name="checkbox5"
                    />
                  }
                  label="Checkbox 5"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IndustryType.checkbox6}
                      onChange={handleIndustryChange}
                      name="checkbox6"
                    />
                  }
                  label="Checkbox 6"
                />
              </FormGroup>
            </FormControl>
          )}
          <Button
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none', color: '#2544EE',
              width: 'fit-content',
              '&:hover': {
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                color: '#FF0000', // Example: Change color on hover
              },
            }}
            variant="contained" onClick={handleViewAllClick1}>
            {IndustryType.showAll ? "Show Less" : "View All"}
          </Button>

          <Typography variant='body1' className='text1Bold' my={1}>Onsite/Remote</Typography>
          <FormControl component="fieldset" sx={{ border: 'none' }}>
            <FormGroup column>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox4}
                    onChange={handleCheckboxChange}
                    name="On site"
                  />
                }
                label="On Site"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox5}
                    onChange={handleCheckboxChange}
                    name="Remote"
                  />
                }
                label="Remote"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IndustryType.checkbox6}
                    onChange={handleCheckboxChange}
                    name="WFH"
                  />
                }
                label=" WFH"
              />
            </FormGroup>
          </FormControl>

        </Stack>

      </Grid>
    </Grid>
  )
}
